import React, { useEffect, useState, useRef } from "react";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import "../menu.css";
import { Ripple } from "primereact/ripple";
import { LoginResponse } from "../../../models/index";
import { wglcsApiService } from "../../../services/WglcsApiService";
import _ from "lodash";
import moment from "moment";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Skeleton } from "primereact/skeleton";
import { FilterMatchMode } from "primereact/api";
import * as XLSX from "xlsx";
import { ProgressSpinner } from "primereact/progressspinner";
import jsPDF from "jspdf";
import "jspdf-autotable";
import EventEmitter, { Events } from "../../../services/eventemitter";
import { DetectEnvironment } from "../../../EnvironmentSettings";
import { t } from "i18next";
import { MultiSelect } from "primereact/multiselect";
import ReactHTMLTableToExcel from "react-html-table-to-excel";

const AllChatTranscriptLink = () => {
    const tableRef = useRef(null);
    var userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;

    const fDate = new Date();
    fDate.setDate(fDate.getDate() - 5);
    const [fromDate, setFromDate] = useState<any>(fDate);
    const [toDate, setToDate] = useState<any>(new Date());
    const [selectedCompanyName, setSelectedCompanyName] = useState<any>(null);
    const [selectedWebsite, setSelectedWebsite] = useState<any>(null);
    const [leadType, setLeadType] = useState<any>(null);
    const [leadtypeArray, setLeadtypeArray] = useState<any>([{ displayName: "All" }, { displayName: "Billable" }, { displayName: "Closed" }]);
    const [loadingCompanies, setLoadingCompanies] = useState(true);
    const [CompanyArray, setCompanyArray] = useState([]);
    const [WebsiteArray, setWebsiteArray] = useState<any>([]);
    const [searchText, setSearchText] = useState("");
    const [tableData, setTableData] = useState<any>([]);
    const [temporaryArray, setTemporaryArray] = useState<any>([]);
    const [loading, setLoading] = useState(false);
    const [refreshState, setRefreshState] = useState<any>(new Date());
    const [hidebutton, setHideButton] = useState(true);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        source: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const skeletonLength = [{ name: "" }, { name: "" }, { name: "" }, { name: "" }, { name: "" }, { name: "" }];
    useEffect(() => {
        EventEmitter.on(Events.forceFullyChangeLanguage, forceFullyChangeLanguage);
    }, []);

    useEffect(() => {
        ApiCalls();
    }, []);

    const forceFullyChangeLanguage = () => {
        setRefreshState(new Date()?.getTime());
    };

    const ApiCalls = async () => {
        loadCompanies();
        setLeadType(leadtypeArray[0]);
    };
    const loadCompanies = async () => {
        let apiResponse = await wglcsApiService.getallCompaniesbyEmployeeCompanyid(userData?.userLoginData?.empCompId.toString());
        var arr = _.orderBy(apiResponse?.data?.data, ["companyName"], ["asc"]);
        setCompanyArray(arr as any);
        setLoadingCompanies(false);
    };
    const onTypeChange = (e) => {
        setLeadType(e.value);
    };
    const commonRequestData = () => {
        return {
            fromDate: moment(fromDate).format("YYYY-MM-DD"),
            toDate: moment(toDate).format("YYYY-MM-DD"),
            companyId: selectedCompanyName?.map((m) => m.companyId).join(","),
            websiteId: selectedWebsite?.map((m) => m.websiteId).join(","),
            timeZone: "",
            timeType: "",
            agentId: 0,
            chatCountBy: "",
            timeFrom: "",
            timeTo: "",
            region: "",
            leadType: leadType?.displayName,
            chatAdvanceFilter: "string",
            chatId: "string",
        };
    };
    const fromData = (e) => {
        setFromDate(e.value);
    };
    const toData = (e) => {
        setToDate(e.value);
    };
    const searchClear = () => {
        setSearchText("");
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            source: { value: null, matchMode: FilterMatchMode.CONTAINS },
        });
        setTableData(temporaryArray);
    };
    const handleSearch = (e) => {
        const value = e.target.value;
        if (value == "other") {
            setFilters({
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                source: { value: "google" as any, matchMode: FilterMatchMode.NOT_CONTAINS },
            });
        } else {
            let _filters1 = { ...filters };

            _filters1["global"].value = value;

            setFilters(_filters1);
        }
        setSearchText(value);
    };

    const ChatTranscriptLink_APi = async () => {
        var result = await wglcsApiService.getallchattranscriptswithlinks(commonRequestData());
        if (result.data.data) {
            setTableData(result.data.data);
            setTemporaryArray(result.data.data);
        } else {
            setTableData([]);
            setTemporaryArray([]);
        }
        setLoading(false);
    };
    const submit = () => {
        if (!selectedCompanyName || selectedCompanyName.length == 0) {
            EventEmitter.emit(Events.DisplayApiErrorResponse, t("toast.Company-validation"));
            return;
        }
        if (!selectedWebsite || selectedWebsite.length == 0) {
            EventEmitter.emit(Events.DisplayApiErrorResponse, t("toast.website-validtion"));
            return;
        } else {
            setLoading(true);
            ChatTranscriptLink_APi();
            setHideButton(false);
        }
    };
    const onCompanyChange = (e) => {
        setSelectedCompanyName(e.value);
        loadWebsites(e?.value?.map((m) => m.companyId).join(","));
    };
    const onWebsiteChange = (e) => {
        setSelectedWebsite(e.value);
    };
    const loadWebsites = async (id) => {
        if (id != null && id != "") {
            let response = await wglcsApiService.getwebsitebymultiplecompids(id);
            if (response.data.data) {
                setWebsiteArray(response.data.data);
            } else {
                setWebsiteArray([]);
            }
        }
    };
    const CompanyOptionTemplate = (option) => {
        if (loadingCompanies) {
            return (
                <div style={{ margin: "2px" }}>
                    <Skeleton></Skeleton>
                </div>
            );
        }
        if (option) {
            return (
                <div className="country-item">
                    <div>{option.companyName}</div>
                </div>
            );
        }
    };
    const renderSearchField = () => {
        return (
            <div className="search-view">
                <input className="searchfeild" value={searchText} onChange={handleSearch} placeholder={t("Search")} />
                <i className="fa-light fa-search search-icon"></i>
                {searchText.length > 0 && <i onClick={searchClear} className="fa fa-times clear-icon"></i>}
            </div>
        );
    };
    const ExportPDF = () => {
        const doc = new jsPDF() as any;
        const pdfWidth = doc.internal.pageSize.getWidth();
        const logoWidth = 45;
        const logoHeight = 15;
        const logoY = 5;
        const centerX = (pdfWidth - logoWidth) / 2;
        const imageElement = document.getElementById("logoImage");
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        ctx?.drawImage(imageElement as any, 0, 0, canvas.width, canvas.height);
        const imgData = canvas.toDataURL("image/svg");
        doc.addImage(imgData, "SVG", centerX, logoY, logoWidth, logoHeight);
        doc.setFontSize(12);
        const text = "All Chat Transcripts with Links";
        const textWidth = (doc.getStringUnitWidth(text) * doc.internal.getFontSize()) / doc.internal.scaleFactor;
        const textX = (pdfWidth - textWidth) / 2;
        doc.text(text, textX, 30);
        doc.text(72, 38, exportSelectedWebsite());
        const headers = [["Chat Id", "Name", "Visitor", "Domain Name", "Day", "Chat Start Time", "Chat End Time", "Department", "Lead Type"]];
        const data = [
            ...tableData.map((item) => [
                item.chatid,
                item.userName,
                item.visitorName,
                item.domainName,
                day_Template(item),
                item.chatStartTime,
                item.chatEndTime,
                item.department,
                item.emailStatus,
            ]),
        ];
        const tableProps = {
            startY: 42,
            head: headers,
            body: [...data],
            headStyles: {
                fontSize: 10, // Adjust the font size
                fontStyle: "normal", // Set fontStyle to 'normal' for regular text
                fillColor: [78, 134, 199], // Adjust the header background color to #4e86c7
                textColor: 255, // Adjust the header text color to white
                cellPadding: 1, // Adjust the padding of header cells
                lineColor: [0, 0, 0], // Adjust the color of lines between header cells
                halign: "center",
            },
            bodyStyles: { fontSize: 8, cellPadding: 2, halign: "center" },
            columnStyles: {
                0: { cellWidth: 18 },
                1: { cellWidth: 18 },
                2: { cellWidth: 20 },
                3: { cellWidth: 27 },
                4: { cellWidth: 22 },
                5: { cellWidth: 20 },
                6: { cellWidth: 20 },
                7: { cellWidth: 22 },
                8: { cellWidth: 20 },
            },
        };
        doc.autoTable(tableProps);
        doc.save("All Chat Transcript with Link");
    };

    const exportSelectedWebsite = () => {
        if (selectedWebsite) {
            return t("From") + ":" + moment(fromDate).format("MM-DD-YYYY") + " " + t("To") + ":" + moment(toDate).format("MM-DD-YYYY");
        } else {
            return "";
        }
    };
    const WebsiteItemTemplate = (option) => {
        return (
            <div className="country-item">
                <div>{option.domainName}</div>
            </div>
        );
    };
    const openLink = (url) => {
        EventEmitter.emit(Events.openNestedWindow, url);
    };

    const day_Template = (rowData) => {
        const dateString = rowData.day;
        const dateObject = new Date(dateString);

        const month = dateObject.getMonth() + 1; // Months are zero-based, so add 1
        const day = dateObject.getDate();
        const year = dateObject.getFullYear();
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const ampm = hours >= 12 ? "PM" : "AM";

        // Convert hours from 24-hour to 12-hour format
        const hours12 = hours % 12 || 12;

        // Zero padding for single digits
        const formattedMonth = month < 10 ? "0" + month : month;
        const formattedDay = day < 10 ? "0" + day : day;
        const formattedHours = hours12 < 10 ? "0" + hours12 : hours12;
        const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
        const formattedSeconds = seconds < 10 ? "0" + seconds : seconds;

        const formattedDate = `${formattedMonth}/${formattedDay}/${year}`;

        return formattedDate;
    };
    const chatTranscript_Template = (rowData) => {
        return (
            <div>
                <p>
                    <a style={{ fontSize: "12px" }} onClick={() => openLink(rowData.url)} rel="noopener noreferrer">
                        <span style={{ color: "#0184cb", textDecoration: "underline" }}>Chat Transcript!</span>
                    </a>
                </p>
            </div>
        );
    };
    const modifiedData = tableData.map((item) => {
        const chatTranscriptLink = `=HYPERLINK("${item.url}", "Chat Link")`;
        let sourceLink;
        if (item.source == "None") {
            sourceLink = item.source;
        } else if (item.source.includes("https://www.google")) {
            sourceLink = `=HYPERLINK("${item.url}", "Google")`;
        } else {
            sourceLink = `=HYPERLINK("${item.url}", "Other")`;
        }
        return {
            ...item,
            chatTranscriptLink,
            sourceLink,
        };
    });

    const source_Template = (rowData) => {
        if (rowData.source == "None") {
            return <span>{rowData.source}</span>;
        }
        if (rowData.source.includes("https://www.google")) {
            return (
                <div>
                    <p>
                        <a style={{ fontSize: "12px" }} onClick={() => openLink(rowData.source)} rel="noopener noreferrer">
                            <span style={{ color: "#0184cb", textDecoration: "underline" }}>Google</span>
                        </a>
                    </p>
                </div>
            );
        }
        return (
            <div>
                <p>
                    <a style={{ fontSize: "12px" }} onClick={() => openLink(rowData.source)} rel="noopener noreferrer">
                        <span style={{ color: "#0184cb", textDecoration: "underline" }}>Other</span>
                    </a>
                </p>
            </div>
        );
    };
    const renderLoader = () => {
        return (
                <ProgressSpinner strokeWidth="3" fill="#EEEEEE" animationDuration=".5s" />
       
        );
    };
    return (
        <>
            {" "}
            <img
                id="logoImage"
                src={process.env.PUBLIC_URL + "/image/" + DetectEnvironment.config.REACT_APP_LOGO}
                alt=""
                style={{ display: "none" }}
            />
            <div className="wgReoprts-container">
                <div className="row p-2">
                    <div className="wgreport-tab viewreport-box">
                        <div className="row view-wgreport ">
                            <div className="col-md-3 col-lg-3 py-1 wgreport">
                                <label className="wgreport-label" htmlFor="firstname6">
                                    {t("smtp-DataTable.Company-Name")}
                                </label>
                                <div className="spinner-box">
                                <MultiSelect
                                    className="form-control"
                                    maxSelectedLabels={2}
                                    filter
                                    showClear
                                    value={selectedCompanyName}
                                    options={CompanyArray}
                                    onChange={(e) => onCompanyChange(e)}
                                    // itemTemplate={CompanyOptionTemplate}
                                    optionLabel="companyName"
                                    placeholder={!loadingCompanies ? t("fieldsPlaceholder.selectCompany") : selectedCompanyName}
                                />
                                {loadingCompanies && renderLoader()}
                                </div>
                            </div>
                            <div className="col-md-3 col-lg-3 py-1 wgreport">
                                <label className="wgreport-label" htmlFor="basic">
                                    {t("MonitoringPanel 6erComponent.Website-Name")}
                                </label>
                                <MultiSelect
                                    className="form-control"
                                    maxSelectedLabels={2}
                                    filter
                                    showClear
                                    value={selectedWebsite}
                                    options={WebsiteArray}
                                    onChange={(e) => onWebsiteChange(e)}
                                    itemTemplate={WebsiteItemTemplate}
                                    optionLabel="domainName"
                                    placeholder={t("ReportComponent.Select Website")}
                                />
                            </div>
                            <div className="col-md-3 col-lg-3 py-1 wgreport">
                                <label className="wgreport-label" htmlFor="firstname6">
                                    {t("ChatTranscriptComponent.From Date")}
                                </label>
                                <Calendar
                                    showIcon
                                    value={fromDate}
                                    onChange={(e) => fromData(e)}
                                    minDate={new Date(new Date().getFullYear(), new Date().getMonth() - 5, 1)}
                                    maxDate={new Date()}
                                />
                            </div>
                            <div className="col-md-3 col-lg-3 py-1 wgreport">
                                <label className="wgreport-label" htmlFor="basic">
                                    {t("ChatTranscriptComponent.To Date")}
                                </label>
                                <Calendar
                                    id="abc"
                                    showIcon
                                    value={toDate}
                                    onChange={(e) => toData(e)}
                                    maxDate={new Date()}
                                    minDate={new Date(fromDate.getFullYear(), fromDate.getMonth(), 1)}
                                />
                            </div>
                      
                            <div className="col-md-3 col-lg-3  py-1 wgreport">
                                <label className="wgreport-label" htmlFor="basic">
                                    {t("DashboardReport-dataTable.Lead-Type")}
                                </label>
                                <Dropdown
                                    className="form-control"
                                    value={leadType}
                                    options={leadtypeArray}
                                    onChange={onTypeChange}
                                    optionLabel="displayName"
                                />
                            </div >
                            <div className="col-md-9 py-1 text-right text-md-left" >
                                {hidebutton == false ? (
                                    <>
                                        <span title={t("wg-buttons.Export-Excel")}>
                                            <ReactHTMLTableToExcel
                                                id="test-table-xlsx-button search-btn"
                                                className="btn-width wgreport-btn wgbtn p-ripple"
                                                table="table-to-xlsx"
                                                filename={t("DashboardReports.AllChat-TranscriptsLinks")}
                                                sheet={t("DashboardReports.AllChat-TranscriptsLinks")}
                                                buttonText={t("wg-buttons.Export-Excel")}
                                            />
                                        </span>
                                        <button
                                            title={t("wg-buttons.Export-PDF")}
                                            className="btn-width wgreport-btn wgbtn p-ripple"
                                            onClick={() => ExportPDF()}
                                        >
                                            {" "}
                                            <Ripple />
                                            {t("wg-buttons.Export-PDF")}
                                        </button>
                                    </>
                                ) : (
                                    ""
                                )}{" "}
                                <button
                                    title={t("wg-buttons.View-Report")}
                                    className="btn-width wgreport-btn wgbtn p-ripple"
                                    onClick={() => submit()}
                                >
                                    {" "}
                                    <Ripple />
                                    {t("wg-buttons.View-Report")}
                                </button>
                            </div >
                        </div >
                    </div >
                </div >
                <div className="row">
                    <div className="col-12 text-center">
                        <div className="wgreport-span">{t("DashboardReports.AllChat-TranscriptsLinks")}</div>
                        <div className="wgreport-span">{exportSelectedWebsite()}</div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">{renderSearchField()}</div>
                </div>
                <div id="report">
                    <div className="row">
                        <div className="col-12">
                            {loading == true ? (
                                <ProgressSpinner
                                    style={{ width: "50px", marginLeft: "50%", marginTop: "10%" }}
                                    strokeWidth="3"
                                    fill="#EEEEEE"
                                    animationDuration=".5s"
                                />
                            ) : (
                                <div className="visitor-data-table">
                                    <DataTable
                                        value={tableData}
                                      
                                        filterDisplay="menu"
                                    
                                        emptyMessage={t("resourcesPoolTable.Data Not Found")}
                                        filters={filters}
                                        paginator
                                        rows={20}
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                        rowsPerPageOptions={[20, 40, 60]}
                                    >
                                        <Column
                                            field="chatid"
                                            header={t("ChatTranscriptComponent.Chat Id")}
                                            filterMatchMode="contains"
                                            sortable
                                        ></Column>
                                        <Column field="userName" header={t("UnsentChat.Name")} filterMatchMode="contains" sortable></Column>
                                        <Column
                                            field="visitorName"
                                            header={t("DashboardReport-dataTable.Visitor")}
                                            filterMatchMode="contains"
                                            sortable
                                        ></Column>
                                        <Column field="domainName" header={t("ManagePoc-DataTable.Domain-Name")} sortable></Column>
                                        <Column body={day_Template} header={t("DashboardReport-dataTable.Day")} sortable />
                                        <Column
                                            field="chatStartTime"
                                            header={t("DashboardReport-dataTable.Chat-StartTime")}
                                            filterMatchMode="contains"
                                            sortable
                                        ></Column>
                                        <Column field="chatEndTime" header={t("DashboardReport-dataTable.Chat-EndTime")} sortable></Column>
                                        <Column field="department" header={t("Chat Logs.Department")} sortable></Column>
                                        <Column field="emailStatus" header={t("DashboardReport-dataTable.Lead-Type")} sortable />
                                        <Column body={chatTranscript_Template} header={t("Transcripts Subscribers.Chat-Transcript")} sortable />
                                        <Column
                                            body={source_Template}
                                            header={t("DashboardReport-dataTable.Source")}
                                            field="source"
                                            filterMatchMode="contains"
                                            sortable
                                        />
                                    </DataTable >
                                </div >
                            )}
                        </div >
                        <div className="htmltable" style={{ display: "none" }}>
                            {tableData && (
                                <table id="table-to-xlsx" ref={tableRef}>
                                    <thead>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td style={{ fontSize: "18px", color: "black", textAlign: "center", fontWeight: 600 }} colSpan={9}>
                                                {t("DashboardReports.AllChat-TranscriptsLinks")}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <th style={{ fontSize: "16px", color: "black", textAlign: "center", fontWeight: 400 }} colSpan={9}>
                                                {exportSelectedWebsite()}
                                            </th>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th>&nbsp;</th>
                                            <th style={{ background: "#84bdf3", border: "1px solid #000" }}>
                                                {t("ChatTranscriptComponent.Chat Id")}
                                            </th>
                                            <th style={{ background: "#84bdf3", border: "1px solid #000" }}>{t("UnsentChat.Name")}</th>
                                            <th style={{ background: "#84bdf3", border: "1px solid #000" }}>
                                                {t("DashboardReport-dataTable.Visitor")}
                                            </th>
                                            <th style={{ background: "#84bdf3", border: "1px solid #000" }}>
                                                {t("ManagePoc-DataTable.Domain-Name")}
                                            </th>
                                            <th style={{ background: "#84bdf3", border: "1px solid #000" }}>{t("DashboardReport-dataTable.Day")}</th>
                                            <th style={{ background: "#84bdf3", border: "1px solid #000" }}>
                                                {t("DashboardReport-dataTable.Chat-StartTime")}
                                            </th>
                                            <th style={{ background: "#84bdf3", border: "1px solid #000" }}>
                                                {t("DashboardReport-dataTable.Chat-EndTime")}
                                            </th>
                                            <th style={{ background: "#84bdf3", border: "1px solid #000" }}>{t("Chat Logs.Department")}</th>
                                            <th style={{ background: "#84bdf3", border: "1px solid #000" }}>
                                                {t("DashboardReport-dataTable.Lead-Type")}
                                            </th>
                                            <th style={{ background: "#84bdf3", border: "1px solid #000" }}>
                                                {t("Transcripts Subscribers.Chat-Transcript")}
                                            </th>
                                            <th style={{ background: "#84bdf3", border: "1px solid #000" }}>
                                                {t("DashboardReport-dataTable.Source")}
                                            </th>
                                        </tr>
                                        {modifiedData.map((item, index) => (
                                            <tr key={index}>
                                                <td>&nbsp;</td>
                                                <td style={{ textAlign: "center", border: "1px solid #000" }}>{item.chatid}</td>
                                                <td style={{ textAlign: "center", border: "1px solid #000" }}>{item.userName}</td>
                                                <td style={{ textAlign: "center", border: "1px solid #000" }}>{item.visitorName}</td>
                                                <td style={{ textAlign: "center", border: "1px solid #000" }}>{item.domainName}</td>
                                                <td style={{ textAlign: "center", border: "1px solid #000" }}>{day_Template(item)}</td>
                                                <td style={{ textAlign: "center", border: "1px solid #000" }}>{item.chatStartTime}</td>
                                                <td style={{ textAlign: "center", border: "1px solid #000" }}>{item.chatEndTime}</td>
                                                <td style={{ textAlign: "center", border: "1px solid #000" }}>{item.department}</td>
                                                <td style={{ textAlign: "center", border: "1px solid #000" }}>{item.emailStatus}</td>
                                                <td
                                                    style={{
                                                        textAlign: "center",
                                                        border: "1px solid #000",
                                                        color: "#0184cb",
                                                        textDecoration: "underline",
                                                    }}
                                                >
                                                    {item.chatTranscriptLink}
                                                </td>
                                                <td style={{ textAlign: "center", border: "1px solid #000" }}>{item.sourceLink}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            </div >
        </>
    );
};
export default AllChatTranscriptLink;
